import React from 'react';
import { H1, H3, H5, IconSpinner, LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { connect } from 'react-redux';
import { useMemo } from 'react';
import { compose } from 'redux';
import ContactForm from './ContactForm/ContactForm';
import { sendContactMessage } from './ContactPage.duck';
import { useIntl } from '../../util/reactIntl';

import css from './ContactPage.module.css';

import image from './contact.png';
import { useCallback } from 'react';

const ContactPage = props => {
  const {
    currentUser,
    sendContactMessageInProgress,
    sendContactMessageError,
    sendContactMessageDone,
    onMessageSubmit,
    scrollingDisabled,
    authInfoLoaded,
  } = props;

  const intl = useIntl();

  const messages = useMemo(
    () => ({
      title: intl.formatMessage({ id: 'ContactPage.title' }),
      description: intl.formatMessage({ id: 'ContactPage.description' }),
      success: intl.formatMessage({ id: 'ContactPage.success' }),
      error: intl.formatMessage({ id: 'General.error' }),
    }),
    [intl]
  );

  const sendContactMessageDoneMaybe = useMemo(
    () => sendContactMessageDone && <H5 className={css.success}>{messages.success}</H5>,
    [messages.success, sendContactMessageDone]
  );
  const sendContactMessageErrorMaybe = useMemo(
    () => sendContactMessageError && <H5 className={css.error}>{messages.error}</H5>,
    [messages.error, sendContactMessageError]
  );

  const handleSubmit = useCallback(
    values => {
      const message = values.message.trim();

      return onMessageSubmit({ ...values, message });
    },
    [onMessageSubmit]
  );

  return (
    <Page title={messages.title} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
        <div className={css.contentWrapper}>
          <div className={css.mainContent}>
            <H1 className={css.pageTitle}>{messages.title}</H1>
            <H3 className={css.subtitle}>{messages.description}</H3>

            {sendContactMessageDoneMaybe}
            {sendContactMessageErrorMaybe}

            {authInfoLoaded ? (
              <ContactForm
                initialValues={{ email: currentUser?.email }}
                onSubmit={handleSubmit}
                inProgress={sendContactMessageInProgress}
                ready={sendContactMessageDone}
              />
            ) : (
              <IconSpinner />
            )}
          </div>
          <div className={css.coverImageWrapper}>
            <img className={css.coverImage} src={image} alt={messages.title} />
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  const { authInfoLoaded } = state.auth;

  const { currentUser } = state.user;

  const {
    sendContactMessageInProgress,
    sendContactMessageError,
    sendContactMessageDone,
  } = state.ContactPage;

  return {
    authInfoLoaded,
    currentUser: currentUser?.attributes,
    sendContactMessageInProgress,
    sendContactMessageError,
    sendContactMessageDone,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const mapDispatchToProps = dispatch => ({
  onMessageSubmit: data => dispatch(sendContactMessage(data)),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(ContactPage);
